import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOwnedGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOwnedGroupsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, ownedGroups: Array<{ __typename?: 'Group', id: string, name: string, photoUrl?: string | null, members: Array<{ __typename?: 'User', id: string }> }> } };


export const GetOwnedGroupsDocument = gql`
    query GetOwnedGroups {
  currentUser {
    id
    ownedGroups {
      id
      name
      photoUrl
      members {
        id
      }
    }
  }
}
    `;

/**
 * __useGetOwnedGroupsQuery__
 *
 * To run a query within a React component, call `useGetOwnedGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnedGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnedGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnedGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>(GetOwnedGroupsDocument, options);
      }
export function useGetOwnedGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>(GetOwnedGroupsDocument, options);
        }
// @ts-ignore
export function useGetOwnedGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>;
export function useGetOwnedGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOwnedGroupsQuery | undefined, GetOwnedGroupsQueryVariables>;
export function useGetOwnedGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>(GetOwnedGroupsDocument, options);
        }
export type GetOwnedGroupsQueryHookResult = ReturnType<typeof useGetOwnedGroupsQuery>;
export type GetOwnedGroupsLazyQueryHookResult = ReturnType<typeof useGetOwnedGroupsLazyQuery>;
export type GetOwnedGroupsSuspenseQueryHookResult = ReturnType<typeof useGetOwnedGroupsSuspenseQuery>;
export type GetOwnedGroupsQueryResult = Apollo.QueryResult<GetOwnedGroupsQuery, GetOwnedGroupsQueryVariables>;